import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { memo, useEffect, useState } from 'react';

dayjs.extend(utc);

function getNext4HourTargetUTC(now = dayjs.utc()) {
    const hour = now.hour();
    const nextHour = Math.ceil((hour + 0.0001) / 4) * 4;
    const target =
        nextHour >= 24
            ? now.startOf('day').add(1, 'day').hour(0)
            : now.startOf('day').hour(nextHour);
    return target;
}

function formatCountdown(ms: number) {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

function CountdownUTC() {
    const [countdown, setCountdown] = useState('');

    useEffect(() => {
        const update = () => {
            const now = dayjs.utc();
            const target = getNext4HourTargetUTC(now);
            const diff = target.diff(now);
            setCountdown(formatCountdown(diff));
        };

        update();
        const interval = setInterval(update, 1000);
        return () => clearInterval(interval);
    }, []);

    return <p className="text-[15px] text-white">{countdown}</p>;
}

export default memo(CountdownUTC);
